import React, { FunctionComponent } from 'react';
import CustomiseSeo from './customiseSeo/CustomiseSeo';
import CustomiseLayout from './layout/CustomiseLayout';
import TestAutomationData from './automationData/TestAutomationData';
import useScrollToWidgetTop from '../../../common/react/useScrollToWidgetTop';
import useUpdateWidgetPadding from '../../hooks/useUpdateWidgetPadding';
import {
  FinCalcSpcContext,
  getFinCalcSpcContextValue,
  IFinCalcSpcContext,
} from '../../../common/react/FinCalcSpcContext';
import PostcodeContextWrapper from '../../../gqlCommon/context/PostcodeContextWrapper';
import CustomizeCarContextProvider from '../../provider/CustomizeCarContextProvider';
import NavigationBarContextProvider from '../../provider/NavigationBarContextProvider';
import SearchCarContextProvider from '../../provider/SearchCarContextProvider';
import StockLockContextProvider from '../../context/stockLock/StockLockContextProvider';
import SoftLockModal from '../../../gqlCommon/components/softLockModal/SoftLockModal';

const CustomiseContainer: FunctionComponent = () => {
  useScrollToWidgetTop();
  useUpdateWidgetPadding();

  const finCalcSpcContextValue: IFinCalcSpcContext = getFinCalcSpcContextValue();

  return (
    <StockLockContextProvider>
      <PostcodeContextWrapper>
        <SearchCarContextProvider>
          <CustomizeCarContextProvider>
            <NavigationBarContextProvider>
              <FinCalcSpcContext.Provider value={finCalcSpcContextValue}>
                <CustomiseLayout />
                <SoftLockModal />
                <TestAutomationData />
                <CustomiseSeo />
              </FinCalcSpcContext.Provider>
            </NavigationBarContextProvider>
          </CustomizeCarContextProvider>
        </SearchCarContextProvider>
      </PostcodeContextWrapper>
    </StockLockContextProvider>
  );
};

export default CustomiseContainer;
